import React, { Fragment } from 'react'
import { Button, ButtonLink, Loader } from 'stylist'
import { Route, Switch } from 'react-router-dom'
import RouteShow from './show'
import RouteEdit from './edit'
import User from 'components/User'
import UserProvider from 'components/User/Provider'
import Header from 'components/Header'
import { userDisplayName } from 'utils/user'

const RouteUser = ({
  match: { url, params },
  history: { goBack },
  location
}) => (
  <UserProvider variables={params}>
    <User
      render={({ loading, user }) =>
        loading ? (
          <Loader size="lg" centered />
        ) : (
          <Fragment>
            <Button marginBottom onClick={goBack} size="sm">
              Back
            </Button>
            <Header>
              <div>
                <h3>{userDisplayName(user)}</h3>
              </div>
              <div>
                {!/\/edit\/?$/.test(location.pathname) && (
                  <ButtonLink to={`${url}/edit`}>Edit</ButtonLink>
                )}
              </div>
            </Header>
            <div>
              <Switch>
                <Route path={`${url}/edit`} component={RouteEdit} />
                <Route path={url} component={RouteShow} />
              </Switch>
            </div>
          </Fragment>
        )
      }
    />
  </UserProvider>
)

export default RouteUser



// WEBPACK FOOTER //
// ./src/routes/admin/users/user.js